import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { WorkflowsOverview } from './overview';
import { BaseComponent } from '../../../components/BaseComponent';
import { WorkflowDetails } from './details';
import { WorkflowProductDetails } from './workflowProductDetails';
import { CompanyWorkflowDetails } from './companyWorkflowDetails';
import { fetchWorkflow } from '../actions';
import { CreateWorkflowModal } from '../components/CreateWorkflowModal';

const Container = styled.div``;

const STATE = {
  editCompanyId: null,
};

/* eslint-disable react/prefer-stateless-function */
class WorkflowsPageComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    // this.props.resetValues();
    if (this.location?.state?.editCompanyId) {
      this.setState({ editCompanyId: this.location?.state?.editCompanyId });
    }
  }

  get location() {
    return this.props.location?.state;
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Container>
        <Switch>
          <Route
            path="(.*)/workflows/:id/workflow-product/:productId(.*)"
            render={component => (
              <WorkflowProductDetails
                workflow_id={component.match.params.id}
                workflow_product_id={component.match.params.productId}
              />
            )}
          />
          <Route path="(.*)/workflows/new(.*)" render={component => <CreateWorkflowModal />} />
          <Route
            path="(.*)/company-workflows/:companyId(.*)/workflows/:workflowId"
            render={component => (
              <CompanyWorkflowDetails
                workflow_id={component.match.params.workflowId}
                company_id={component.match.params.companyId}
              />
            )}
          />
          <Route
            path="(.*)/workflows/:id(.*)"
            render={component => (
              <WorkflowDetails workflow_id={component.match.params.id} editCompanyId={this.state.editCompanyId} />
            )}
          />
          <Route component={WorkflowsOverview} />
        </Switch>
      </Container>
    );
  }
}

WorkflowsPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchWorkflow(ownProps.workflow_id));
    },
    // resetValues() {
    //   dispatch(resetInvoiceValues());
    // },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WorkflowsPage = compose(withConnect, withRouter)(WorkflowsPageComp);
